/* eslint-disable react/jsx-key */
import 'twin.macro';

const location = window.location.host;

export const containerInfo = [
  {
    title: 'Банковским переводом (SWIFT)',
    caption: 'На свой счёт в долларах, евро или рублях',
    info: [
      'Перевод можно отправить в долларах, евро или рублях (из российского банка).',
      <span>
        Реквизиты ваших счетов доступны в мобильном приложении Freedom Bank и в разделе{' '}
        <a href='/' tw='underline cursor-pointer'>
          “Мои документы”.
        </a>
      </span>,
      'Лимиты и комиссии — согласно тарифов банка-отправителя.',
      'Банк оставляет за собой право запросить документы, подтверждающие источник происхождения денег.'
    ]
  },
  {
    title: 'Переводом с карты Visa или Mastercard',
    caption: 'Подойдёт любая карта Visa или Mastercard, кроме выпущенных в РФ',
    info: [
      'Пополнить свою карту можно с любой карты Visa или Mastercard (кроме выпущенных в РФ) через мобильное приложение Freedom Bank в разделе «Переводы» — «С карты на карту».',
      'Лимиты на переводы с карт Visa: на один перевод — 25 000 $, сумма переводов в сутки — 50 000 $, в неделю — 100 000 $, в месяц — 200 000 $ (эквивалент в валюте перевода).',
      'Лимиты на переводы с карт Mastercard: на один перевод — 5 000 $, сумма переводов в месяц — 10 000 $ (эквивалент в валюте перевода).',
      'У нас нет комиссий на пополнение с карт. Но комиссии и ограничения могут быть у банка, выпустившего карту отправителя.'
    ]
  },
  {
    title: 'Переводом с карты МИР',
    caption: 'С помощью сервиса Moneysend',
    info: [
      <span>
        Для перевода денег с карт МИР на карту Freedom Bank воспользуйтесь сервисом
        <a tw='underline cursor-pointer' href='https://moneysend.money' target='_blank' rel='noreferrer'>
          Moneysend.
        </a>
      </span>,
      'Лимиты и комиссии — согласно условий сервиса.',
      'Банк, выпустивший карту отправителя, может дополнительно удержать свою комиссию.'
    ]
  },
  {
    title: 'Со счёта Цифра Банка (РФ)',
    caption: 'В долларах, евро, рублях и тенге из мобильного приложения Цифра Банка',
    info: [
      <span>
        В мобильном приложении Цифра Банка переведите деньги по номеру телефона на свою карту или счёт, открытые в
        Казахстане. <a tw='underline cursor-pointer'>Подробная инструкция.</a>
      </span>,
      'Валюты перевода — доллары, евро, рубли и тенге.',
      'Лимиты и комиссии — согласно условий Цифра Банка.',
      <span>
        Заказать карту Цифра Банка можно <a tw='underline cursor-pointer'>онлайн</a> или{' '}
        <a tw='underline cursor-pointer'>в отделениях на территории РФ</a>, пополнить — через систему быстрых переводов
        из любого банка РФ.
      </span>
    ]
  },
  {
    title: 'Наличными в банкомате или отделении банка',
    caption: 'на территории Казахстана',
    info: [
      <span>
        Пополняйте счета в <a tw='underline cursor-pointer'>банкоматах и отделениях Freedom Bank</a> и{' '}
        <a tw='underline cursor-pointer'>кассах Freedom Mobile</a> на территории Казахстана.
      </span>,
      'Банкоматы банка и кассы Freedom Mobile принимают только тенге.',
      'В отделении Банка принимают тенге и иностранную валюту.',
      'Банк оставляет за собой право запросить документы, подтверждающие источник происхождения денег.'
    ]
  }
];

export const containerInfo2 = [
  {
    title: 'Банковским переводом (SWIFT)',
    caption: 'В рублях или долларах из мобильного приложения Freedom Bank',
    info: [
      'Перевод можно отправить в рублях или долларах из мобильного приложения Freedom Bank.',
      'Вам понадобятся банковские реквизиты получателя.',
      'Перевод занимает от 3 рабочих дней.',
      'Комиссии от 0,15% от суммы перевода (минимум 8 000 тенге или эквивалент в валюте).',
      'Банк оставляет за собой право запросить документы, подтверждающие источник происхождения денег.'
    ],
    withSticker: true
  },
  {
    title: 'Переводом на карту Visa или Mastercard',
    caption: 'кроме выпущенных в РФ',
    info: [
      'Перевести деньги можно на любую карту Visa или Mastercard (кроме выпущенных в РФ) через мобильное приложение Freedom Bank в разделе «Переводы» — «С карты на карту».',
      'Деньги поступят моментально.',
      'Лимит на один перевод — 5 000 $, сумма всех переводов за сутки — 20 000 $, за неделю — 50 000 $, за месяц — 100 000 $ (эквивалент в валюте перевода).',
      <span key={'1'}>
        Комиссии за перевод: <br />
        другому клиенту Freedom Bank — бесплатно; <br /> на карту другого казахстанского банка — 1,5% от суммы перевода;
        <br /> на карту неказахстанского банка — 1% от суммы перевода (минимум 250 тенге).
      </span>
    ]
  },
  {
    title: 'Банковским переводом по Казахстану',
    caption: 'В тенге по номеру счёта',
    info: [
      'Перевести деньги в любой банк Казахстана можно в мобильном приложении Freedom Bank.',
      'Лимит — 10 млн тенге на одну операцию. Количество операций не ограничено.',
      'Комиссия — 200 тенге.'
    ]
  },
  {
    title: 'Наличными в отделении банка или банкоматах',
    caption: 'на территории Казахстана и других стран, за исключением РФ',
    info: [
      <b>В банкоматах или кассах Freedom Bank</b>,
      'Лимит в банкоматах — 500 000 тенге в месяц (или эквивалент в валюте).',
      'Лимитов на снятие с карты с помощью pos-терминала нет.',
      'Комиссия — 1,5% от суммы (минимум 1 500 тенге или эквивалент в валюте).',
      <b>В кассе Freedom Bank без предъявления карты</b>,
      'Лимитов нет.',
      'Комиссия — 2% от суммы.',
      <b>В банкоматах и кассах других казахстанских банков</b>,
      'Лимит в банкоматах — 500 000 тенге в месяц (или эквивалент в валюте).',
      'Лимитов на снятие с карты с помощью pos-терминала нет (но они могут быть у банка, в котором вы снимаете наличные).',
      'Комиссия — 1,5% от суммы (минимум 1 500 тенге или эквивалент в валюте).',
      <b>В банкоматах и кассах банков вне Казахстана и России</b>,
      'Лимит в банкоматах — 500 000 тенге в месяц (или эквивалент в валюте).',
      'Лимитов на снятие с карты с помощью pos-терминала нет (но они могут быть у банка, в котором вы снимаете наличные).',
      'Комиссия — 2% от суммы + 1 500 тенге (или эквивалент в валюте).',
      'Лимит на снятие наличных в банкоматах можно изменить в мобильном приложении  Freedom Bank или обратившись в колл-центр банка.'
    ]
  }
];

export const answersDeposit = [
  [
    {
      question: 'Что нужно для открытия карты?',
      answer: (
        <span>
          Заграничный паспорт, ИИН (индивидуальный идентификационный номер) Республики Казахстан и сотовый номер
          телефона для приёма SMS.
        </span>
      )
    },
    {
      question: 'С какого возраста можно оформить карту?',
      answer: 'С 18 лет.'
    },
    {
      question: 'Можно ли получить карту по доверенности?',
      answer: 'К сожалению, нет. Карта выдается только лично. Не забудьте захватить загранпаспорт.'
    },
    {
      question: 'Пластиковая карта: как заказать, сколько ждать и где забирать?',
      answer: (
        <span>
          Депозитная карта выпускается только в нецифровом (пластиковом) виде. Оформить и получить её можно в отделениях
          Freedom Bank, после предварительного заказа на сайте.
          <br /> Для получения вам потребуется ИИН и загранпаспорт.
        </span>
      )
    },
    {
      question: 'Как активировать карту?',
      answer:
        'Никак, карты активируются автоматически. Вы получите SMS об активации в течение 20 минут после получения пластиковой карты.'
    }
  ],
  [
    {
      question: 'Когда я смогу начать пользоваться картой?',
      answer: (
        <span>
          Сразу после получения SMS об активации. Она придёт в течение 20 минут после получения пластиковой карты.
        </span>
      )
    },

    {
      question: 'Как установить или сменить ПИН-код?',
      answer: 'В мобильном приложении  Freedom Bank или любом банкомате Freedom Bank.'
    },
    {
      question: 'С какого счёта будут списываться деньги при покупке с карты?',
      answer: (
        <span>
          Деньги списываются с того счёта, в валюте которого у вас оплата. Например, если вы оплачиваете покупку в тенге
          — деньги спишутся со счёта в тенге. <br />
          Если на счету недостаточно денег, оставшаяся сумма автоматически спишется с другого счёта. Приоритетность
          списания со счетов следующая:
          <br />
          <br /> ТЕНГЕ, ДОЛЛАРЫ, ЕВРО, РУБЛИ, ЮАНЬ, ЛИРА, ДИРХАМ;
          <br /> ДОЛЛАРЫ, ТЕНГЕ, ЕВРО, РУБЛИ, ЮАНЬ, ЛИРА, ДИРХАМ;
          <br /> ЕВРО, ТЕНГЕ, ДОЛЛАРЫ, РУБЛИ, ЮАНЬ, ЛИРА, ДИРХАМ;
          <br /> РУБЛИ, ТЕНГЕ, ДОЛЛАРЫ, ЕВРО, ЮАНЬ, ЛИРА, ДИРХАМ;
          <br />
          ЮАНЬ, ТЕНГЕ, ДОЛЛАРЫ, ЕВРО, РУБЛИ, ЛИРА, ДИРХАМ;
          <br />
          ЛИРА, ТЕНГЕ, ДОЛЛАРЫ, ЕВРО, РУБЛИ, ЮАНЬ, ДИРХАМ;
          <br />
          ДИРХАМ, ТЕНГЕ, ДОЛЛАРЫ, ЕВРО, РУБЛИ, ЮАНЬ, ЛИРА.
          <br />
          Если валюта оплаты не совпадает ни с одной валютой счёта, деньги спишутся в долларах.
        </span>
      )
    },
    {
      question: 'Где взять реквизиты для безналичного пополнения карты переводом?',
      answer: <span>В мобильном приложении Freedom Bank в разделе “Реквизиты”.</span>
    }
  ],
  [
    {
      question: 'Нужно ли уведомлять налоговые органы своей страны об открытии и закрытии счетов в иностранных банках?',
      answer: <span>Уточните в налоговой службе вашей страны.</span>
    },
    {
      question: 'Какие налоги и как я должен буду платить?',
      answer: (
        <span>
          Согласно законам Республики Казахстан, иностранные граждане обязаны уплачивать индивидуальный подоходный налог
          (ИПН) с доходов от вознаграждения по вкладам. <br />
          <br />
          Банк, как налоговый агент, будет делать это за вас, удерживая ИПН в размере 15% с вашего счёта (или 20%, если
          вы зарегистрированы в государстве{' '}
          <a href='https://adilet.zan.kz/rus/docs/V1800016404' tw='underline'>
            с льготным налогообложением)
          </a>
          .
        </span>
      )
    }
  ],
  [
    {
      question: 'Моя карта не отображается в приложении',
      answer: 'Карта появляется в приложении в течение 20 минут после выпуска карты. '
    },
    {
      question: 'С моей карты списали 30 000 тенге сразу после её пополнения. Что это было?',
      answer: (
        <span>
          Скорее всего, банк списал комиссию за выпуск карты. Это происходит при её первом пополнении и ровно один раз.
          <br />
          <a
            href={`https://bankffin.kz/docs/tariffs_depositcard_ru.pdf?v=1.6`}
            target={'_blank'}
            tw='border-b divide-y'
            rel='noreferrer'
          >
            Все тарифы по карте
          </a>
        </span>
      )
    },

    {
      question: 'Как связаться со службой поддержки?',
      answer: '595 (бесплатно для звонков из Казахстана)'
    }
  ],
  [],
  []
];

export const containerInfo2Invest = [
  {
    title: 'Банковским переводом (SWIFT)',
    caption: 'В рублях или долларах ',
    info: [
      <span>Есть два способа сделать перевод:</span>,
      <span>
        &nbsp;&nbsp; из приложения Tradernet.Global можно перевести деньги с торгового счёта на свой банковский счёт в
        любом банке;
        <br />
        &nbsp;&nbsp; из мобильного приложения Freedom Bank — с накопительного D-счета — на любой банковский счёт.
      </span>,
      <span>
        <b>В приложении Tradernet.Global </b>
      </span>,
      <span>Выберите “Неторговые поручения” → “Вывод денег”.</span>,
      <span>Перевод занимает от 3 рабочих дней и возможен только на свой счёт в любом банке.</span>,
      <span>
        Вывод на счёт во Freedom Bank — без комиссии, на счёт другого банка — согласно тарифам Freedom Finance Global
        PLC.
      </span>,
      <span>
        <b>В мобильном приложении Freedom Bank</b>
      </span>,
      <span>
        Предварительно переведите деньги с торгового счёта на D-счёт (в приложении Tradernet.Global выберите “Неторговые
        поручения” → “Перевод между счетами”).
      </span>,
      <span>Далее в мобильном приложении Freedom Bank в разделе “Переводы” выберите “SWIFT”.</span>,
      <span>Перевод занимает от 3 рабочих дней и возможен на любой банковский счёт.</span>,
      <span>
        Комиссии:
        <br /> &nbsp; в рублях — от 0,1% суммы перевода (от 5 000 до 20 000 тенге);
        <br /> &nbsp; в долларах — от 0,2% суммы перевода (от 5 000 до 60 000 тенге).
      </span>,
      <span>Банк оставляет за собой право запросить документы, подтверждающие источник происхождения денег.</span>
    ],
    withSticker: true
  },
  {
    title: 'Переводом на карту Visa или Mastercard',
    caption: 'кроме выпущенных в РФ',
    info: [
      'Предварительно переведите деньги с торгового счёта на D-счёт (в приложении Tradernet.Global выберите “Неторговые поручения” → “Перевод между счетами”).',
      'Перевести деньги с D-счёта можно на любую карту Visa или Mastercard (кроме выпущенных в РФ) через мобильное приложение Freedom Bank в разделе «Переводы» → «С карты на карту».',
      'Лимит на один перевод — 5 000 $, суммарно в месяц — 100 000 $ (или эквивалент в валюте).',
      <span>
        Лимиты на переводы с карт Mastercard: на один перевод — 5 000 $, сумма всех переводов за сутки — 20 000 $, за
        неделю — 50 000 $, за месяц — 100 000 $ (эквивалент в валюте перевода).
      </span>,
      <span>
        Комиссии за перевод: <br />
        &nbsp; &nbsp;на другую карту инвестора — бесплатно;
        <br />
        &nbsp; &nbsp;на другую карту Freedom Bank (свою или чужую) — 3%; <br />
        &nbsp; &nbsp; на карту любого другого банка — 3% (минимум 500 тенге).
      </span>
    ]
  },
  {
    title: 'Банковским переводом по Казахстану',
    caption: 'В тенге по номеру счёта',
    info: [
      'Предварительно переведите деньги с торгового счёта на D-счёт (в приложении Tradernet.Global выберите “Неторговые поручения” → “Перевод между счетами”). ',
      'Перевести деньги с D-счёта на счёт любого казахстанского банка можно в мобильном приложении Freedom Bank в разделе «Переводы» → «Межбанковский перевод».      ',
      'Лимит — 10 млн тенге на одну операцию. Количество операций не ограничено.',
      'Комиссия — 3% от суммы перевода (минимум 500 тенге).'
    ]
  },
  {
    title: 'Наличными в отделении банка или банкоматах',
    caption: 'на территории Казахстана и других стран, за исключением РФ',
    info: [
      'Предварительно переведите деньги с торгового счёта на D-счёт (в приложении Tradernet.Global выберите “Неторговые поручения” → “Перевод между счетами”).',
      <b>В банкоматах или кассах любого банка (за исключением банков РФ) </b>,
      'Лимит в банкоматах — 100 000 долларов в месяц (или эквивалент в валюте).',
      'Лимитов на снятие с карты с помощью pos-терминала нет (но они могут быть у банка, в котором вы снимаете деньги).',
      'Комиссия — 3% от суммы (минимум 500 тенге).',
      <b>В кассе Freedom Bank без предъявления карты</b>,
      'Лимитов нет.',
      'Комиссия — 3% от суммы (минимум 500 тенге).',
      <span>
        Карта должна быть привязана к кошельку{' '}
        <a href='https://bankffin.kz/ru/page/36-kak-podklyuchit-kartu-k-apple-pay-na-smartfone' tw='underline'>
          &nbsp; Apple Pay,
        </a>
        <a href='https://www.bankffin.kz/ru/cards/samsung-pay-info' tw='underline'>
          &nbsp; Samsung Pay,
        </a>
        <a href='https://www.bankffin.kz/ru/39-kak-podklyuchit-kartu-k-google-pay-na-smartfone' tw='underline'>
          &nbsp; Google Pay.
        </a>
      </span>,
      'Лимит на снятие наличных в банкоматах можно изменить в мобильном приложении Freedom Bank или в колл-центре банка.'
    ]
  }
];

export const FAQInvest = [
  [
    {
      question: 'Что нужно для открытия карты?',
      answer:
        'Заграничный паспорт, ИИН Республики Казахстан (индивидуальный идентификационный номер) и мобильный номер телефона для приёма SMS.'
    },
    { question: 'С какого возраста можно оформить карту?', answer: 'С 18 лет.' },
    {
      question: 'Можно ли открыть вторую карту инвестора?',
      answer: 'Нет, на одного человека можно открыть только одну карту.'
    },
    {
      question: 'Пластиковая карта: как заказать, сколько ждать и где забирать?',
      answer: (
        <span>
          Оформить её можно в любом отделении Freedom Bank.
          <br />
          Для получения потребуется загранпаспорт.
        </span>
      )
    },
    {
      question: 'Как активировать карту?',
      answer:
        'Карты активируются автоматически. Вы получите SMS об активации в течение 20 минут после получения пластиковой карты.'
    }
  ],
  [
    {
      question: 'Когда я смогу начать пользоваться картой?',
      answer: 'Сразу после получения SMS об активации. Она придёт в течение 20 минут после получения пластиковой карты.'
    },

    {
      question: 'Как установить или сменить ПИН-код?',
      answer: 'В мобильном приложении  Freedom Bank или в любом банкомате Freedom Bank (потребуется пластиковая карта).'
    },
    {
      question: 'С какого счёта будут списываться деньги при покупке с карты?',
      answer: (
        <span>
          Деньги списываются с того счёта, в валюте которого у вас оплата. Например, если вы оплачиваете покупку в тенге
          — деньги спишутся со счёта в тенге. <br />
          Если на счету недостаточно денег, оставшаяся сумма автоматически спишется с другого счёта. Приоритетность
          списания со счетов следующая: <br />
          &nbsp; тенге, доллары, евро, рубли; <br />
          &nbsp; доллары, тенге, евро, рубли; <br />
          &nbsp; евро, тенге, доллары, рубли; <br />
          &nbsp; рубли, тенге, доллары, евро. <br />
          <br />
          Если валюта оплаты не совпадает ни с одной валютой счёта, деньги спишутся в долларах.
        </span>
      )
    },
    {
      question: 'Как узнать реквизиты карты?',
      answer:
        'В мобильном приложении Freedom Bank в разделе “Реквизиты”. Их можно скопировать или сразу отправить другому человеку.'
    },
    {
      question: 'Я могу оплачивать покупки картой?',
      answer: 'Да, деньги при оплате списываются с вашего накопительного D-счёта.'
    },
    {
      question: 'Как добавить карту в мобильный кошелёк?',
      answer: (
        <span>
          У нас есть инструкции для
          <a href='https://bankffin.kz/ru/page/36-kak-podklyuchit-kartu-k-apple-pay-na-smartfone' tw='underline'>
            &nbsp; Apple Pay,
          </a>
          <a href='https://www.bankffin.kz/ru/cards/samsung-pay-info' tw='underline'>
            &nbsp; Samsung Pay,
          </a>
          <a href='https://www.bankffin.kz/ru/39-kak-podklyuchit-kartu-k-google-pay-na-smartfone' tw='underline'>
            &nbsp; Google Pay.
          </a>
        </span>
      )
    }
  ],
  [
    {
      question: 'Как открыть брокерский счёт?',
      answer: (
        <span>
          Вам понадобятся заграничный паспорт и мобильный номер, чтобы получать SMS.
          <br />
          <br />
          Скачайте мобильное приложение Tradernet.Global (
          <a
            href='https://apps.apple.com/kz/app/tradernet-global/id1558692227'
            tw='underline'
            target='_blank'
            rel='noreferrer'
          >
            App Store
          </a>
          ,
          <a
            href='https://play.google.com/store/apps/details?id=global.tradernet.terminal&hl=ru&gl=KZ'
            tw='underline'
            target='_blank'
            rel='noreferrer'
          >
            Google Play
          </a>
          ), выберите “регистрация” и следуйте инструкциям.
          <br />
          <br />
        </span>
      )
    },
    {
      question: 'Есть ли баланс у карты?',
      answer:
        'Баланс карты — это баланс накопительного D-счёта. Деньги находятся во Freedom Finance Global PLC. Карта служит быстрым доступом к накопительному D-счёту и отражает его баланс.'
    },
    {
      question: 'Что такое Freedom Finance Global PLC?',
      answer:
        'Инвестиционная компания. Предоставляет брокерское обслуживание, доверительное управление ценными бумагами и доступ к фондовым рынкам Казахстана, России и США. Freedom Finance Global PLC является частью холдинга Freedom Holding Corp.'
    },
    { question: 'Что такое торговый счёт?', answer: 'Счёт для покупки и продажи акций международных компаний.' },
    {
      question: 'Что такое накопительный D-счёт?',
      answer: (
        <span>
          Счёт для хранения денег. Карта инвестора отражает его баланс. D-счёт можно использовать для оплаты покупок,
          переводов, пополнения или вывода денег с торгового счёта в долларах, тенге, евро и рублях.
          <br /> <br />
          На остаток счета Freedom Finance Global PLC ежедневно начисляет фиксированный доход в долларах в размере 3%
          годовых. <br /> <br />
          Freedom Finance Global PLC не является участником Казахстанского фонда гарантирования депозитов.
        </span>
      )
    },
    {
      question: 'Нужно ли привязывать карту внутри платформы Tradernet?',
      answer: 'Нет, карта автоматически привязывается к вашему накопительному D-счёту.'
    }
  ],
  [
    {
      question: 'Есть ли комиссия при пополнении карты?',
      answer: 'У нас нет комиссий на пополнение. Но комиссии и ограничения могут быть у банка-отправителя.'
    },
    {
      question: 'На какой счёт и как быстро поступают деньги при пополнении карты?',
      answer: (
        <span>
          При пополнении карты деньги моментально поступают на накопительный D-счёт.
          <br />
          <br />С него их можно перевести на торговый счёт для покупки акций.
        </span>
      )
    },
    {
      question: 'Как перевести деньги на торговый счёт?',
      answer: (
        <span>
          Без комиссий и ограничений:
          <ul tw='list-disc ml-5'>
            <li>в приложении Tradernet.Global: в разделе “Неторговые поручения” выберите “Перевод между счетами”;</li>
            <li>в мобильном приложении Freedom Bank: в разделе “Переводы” выберите “На брокерский счёт”.</li>
          </ul>
        </span>
      )
    },
    { question: 'Есть ли комиссия при переводе денег с накопительного на торговый счёт?', answer: 'Нет.' },
    {
      question: 'Как снять наличные с карты?',
      answer: 'Снять деньги можно в банкоматах или кассах любого банка (за исключением банков на территории РФ).'
    },
    {
      question: 'Есть ли комиссия за снятие денег?',
      answer: 'Да. Ознакомиться с комиссиями можно в разделе “Условия и тарифы”.'
    },
    {
      question: 'Могу ли я снимать деньги с карты или пополнять её в другой валюте?',
      answer: 'Да, конвертация валют произойдёт автоматически по банковскому курсу на момент снятия или пополнения. '
    },
    {
      question: 'Можно ли снимать наличные без пластиковой карты?',
      answer: (
        <span>
          Да, снять наличные без карты можно через POS-терминал в кассах Freedom Bank (карта должна быть привязана к
          кошельку
          <a href='https://bankffin.kz/ru/page/36-kak-podklyuchit-kartu-k-apple-pay-na-smartfone' tw='underline'>
            &nbsp; Apple Pay,
          </a>
          <a href='https://www.bankffin.kz/ru/cards/samsung-pay-info' tw='underline'>
            &nbsp; Samsung Pay или
          </a>
          <a href='https://www.bankffin.kz/ru/39-kak-podklyuchit-kartu-k-google-pay-na-smartfone' tw='underline'>
            &nbsp; Google Pay.
          </a>
          ).
        </span>
      )
    },
    {
      question: 'Какие переводы можно делать в мобильном приложении  Freedom Bank?',
      answer: (
        <span>
          <ul tw='list-disc ml-5'>
            <li>Между своими картами и счетами Freedom Bank;</li>
            <li>на любую карту внутри и за пределами Казахстана (за исключением карт, выпущенных банками РФ);</li>
            <li>на счета других банков.</li>
          </ul>
        </span>
      )
    },
    {
      question: 'Как конвертировать валюту внутри карты?',
      answer: 'В разделе “Конвертация” мобильного приложения Freedom Bank.'
    }
  ],
  [
    {
      question: 'Нужно ли уведомлять налоговые органы своей страны об открытии и закрытии счетов в иностранных банках?',
      answer: <span>Уточните в налоговой службе вашей страны.</span>
    }
  ],
  [
    {
      question: 'Моя карта не отображается в приложении',
      answer: (
        <span>
          Карта появляется в приложении в течение 20 минут после получения пластиковой.
          <br />
        </span>
      )
    },

    {
      question: 'У меня больше нет доступа к моему мобильному номеру. Что делать?',
      answer: 'Чтобы изменить контактный номер, обратитесь в ближайшее отделение банка.'
    },
    {
      question: 'У меня проблема с брокерским счётом или приложением Tradernet.Global. Куда обращаться?',
      answer: 'Обратитесь в колл-центр по номеру 7555.'
    },
    {
      question: 'Как связаться со службой поддержки?',
      answer: <span>595 (бесплатно для звонков из Казахстана)</span>
    }
  ]
];

export const answersPrepaidFunction = (prepaidCardLimit, activeTab) => {
  switch (activeTab) {
    case 1:
      return [
        {
          question: 'Что нужно для открытия карты?',
          answer: 'Только номер мобильного телефона для приёма SMS.'
        },
        {
          question: 'Можно ли открыть вторую карту?',
          answer: `На один номер телефона можно открыть до ${prepaidCardLimit} карт в месяц.`
        },
        {
          question: 'Как заказать пластиковую карту?',
          answer: 'Предоплаченные карты выпускаются только в цифровом виде.'
        },
        {
          question: 'Как активировать карту?',
          answer: 'Карта активируется автоматически.'
        },
        {
          question: 'Где узнать данные карты?',
          answer: 'Данные карты вы получите после её покупки. Часть — на сайте, часть — в SMS.'
        }
      ];
    case 2:
      return [
        {
          question: 'Когда я смогу начать пользоваться картой?',
          answer: 'Сразу после получения SMS с данными карты.'
        },
        {
          question: 'Как узнать баланс карты?',
          answer: 'После каждой покупки или перевода вы будете получать SMS с текущим балансом карты.'
        },
        // {
        //   question: 'Как установить или сменить ПИН-код?',
        //   answer: 'ПИН-код вы получите в SMS сразу после выпуска карты. Сменить его нельзя.'
        // },
        {
          question: 'Конвертации',
          answer:
            'Валюта карты — доллары США. Конвертация в валюту покупки будет происходить по обменному курсу Freedom Bank.'
        },
        {
          question: 'Как узнать реквизиты и пополнить карту?',
          answer: 'Предоплаченные карты пополнять нельзя. У них нет номера счёта.'
        },
        {
          question: 'Что произойдёт с деньгами на карте, когда её срок действия закончится?',
          answer: 'Неиспользованная вами сумма на карте сгорает.'
        },
        {
          question: 'Как закрыть карту?',
          answer: 'Никак. Карта закроется автоматически, когда вы потратите все деньги или закончится срок её действия.'
        },
        {
          question: 'Как добавить карту в мобильный кошелёк?',
          answer: (
            <span>
              У нас есть инструкции для
              <a href='https://bankffin.kz/ru/page/36-kak-podklyuchit-kartu-k-apple-pay-na-smartfone' tw='underline'>
                &nbsp; Apple Pay,
              </a>
              <a href='https://www.bankffin.kz/ru/cards/samsung-pay-info' tw='underline'>
                &nbsp; Samsung Pay,
              </a>
              <a href='https://www.bankffin.kz/ru/39-kak-podklyuchit-kartu-k-google-pay-na-smartfone' tw='underline'>
                &nbsp; Google Pay.
              </a>
            </span>
          )
        },
        {
          question: 'Как перевести деньги с предоплаченной на другую карту?',
          // answer: <span>С помощью сервиса перевода с карты на карту</span>
          answer: 'Переводить с предоплаченной карты нельзя'
        },
        {
          question: 'Как снять наличные с карты?',
          answer: 'Снять деньги с предоплаченной карты нельзя.'
        }
      ];
    case 3:
      return [
        {
          question:
            'Нужно ли уведомлять налоговые органы своей страны об открытии предоплаченной карты в иностранном банке?',
          answer:
            'Предоплаченные карты не предполагают открытия полноценного банковского счёта. Поэтому уведомлять налоговые органы об открытии такой карты не нужно.'
        }
      ];
    case 4:
      return [
        {
          question: 'Я потерял данные карты, что делать?',
          answer:
            'К сожалению, восстановить данные карты, перевыпустить её или вернуть вам оставшиеся деньги невозможно.'
        },
        {
          question: 'Не пришла SMS с данными карты ',
          answer: (
            <span>
              Обратитесь в службу заботы о пользователях: <br /> 8 800 555 89 90 (для звонков) <br /> +7 776 0 595 595
              (whatsapp для клиентов за рубежом) <br /> salem@bankffin.kz
            </span>
          )
        },
        {
          question: 'Как связаться со службой поддержки?',
          answer: (
            <span>
              8 800 555 89 90 (для звонков) <br /> +7 776 0 595 595 (whatsapp для клиентов за рубежом) <br />{' '}
              salem@bankffin.kz
            </span>
          )
        }
      ];
    default:
      break;
  }
};

export const answersPrepaid = [
  [
    {
      question: 'Что нужно для открытия карты?',
      answer: 'Только номер мобильного телефона для приёма SMS.'
    },
    {
      question: 'Можно ли открыть вторую карту?',
      answer: 'На один номер телефона можно открыть до 25 карт в месяц.'
    },
    {
      question: 'Как заказать пластиковую карту?',
      answer: 'Предоплаченные карты выпускаются только в цифровом виде.'
    },
    // {
    //   question: 'Как подарить предоплаченную карту?',
    //   answer: (
    //     <span>
    //       Предоплаченная карта привязывается к номеру телефона, который вы указываете при её покупке. На этот же номер
    //       приходят SMS с частью данных карты (срок действия, CVV).
    //       <br />
    //       <br />
    //       Если в процессе покупки вы указываете не свой номер телефона, будьте готовы получить код подтверждения с этого
    //       номера, чтобы завершить покупку.
    //     </span>
    //   )
    // },
    {
      question: 'Как активировать карту?',
      answer: 'Карта активируется автоматически.'
    },
    {
      question: 'Где узнать данные карты?',
      answer: 'Данные карты вы получите после её покупки. Часть — на сайте, часть — в SMS.'
    }
  ],
  [
    {
      question: 'Когда я смогу начать пользоваться картой?',
      answer: 'Сразу после получения SMS с данными карты.'
    },
    {
      question: 'Как узнать баланс карты?',
      answer: 'После каждой покупки или перевода вы будете получать SMS с текущим балансом карты.'
    },
    // {
    //   question: 'Как установить или сменить ПИН-код?',
    //   answer: 'ПИН-код вы получите в SMS сразу после выпуска карты. Сменить его нельзя.'
    // },
    {
      question: 'Конвертации',
      answer:
        'Валюта карты — доллары США. Конвертация в валюту покупки будет происходить по обменному курсу Freedom Bank.'
    },
    {
      question: 'Как узнать реквизиты и пополнить карту?',
      answer: 'Предоплаченные карты пополнять нельзя. У них нет номера счёта.'
    },
    {
      question: 'Что произойдёт с деньгами на карте, когда её срок действия закончится?',
      answer: 'Неиспользованная вами сумма на карте сгорает.'
    },
    {
      question: 'Как закрыть карту?',
      answer: 'Никак. Карта закроется автоматически, когда вы потратите все деньги или закончится срок её действия.'
    },
    {
      question: 'Как добавить карту в мобильный кошелёк?',
      answer: (
        <span>
          У нас есть инструкции для
          <a href='https://bankffin.kz/ru/page/36-kak-podklyuchit-kartu-k-apple-pay-na-smartfone' tw='underline'>
            &nbsp; Apple Pay,
          </a>
          <a href='https://www.bankffin.kz/ru/cards/samsung-pay-info' tw='underline'>
            &nbsp; Samsung Pay,
          </a>
          <a href='https://www.bankffin.kz/ru/39-kak-podklyuchit-kartu-k-google-pay-na-smartfone' tw='underline'>
            &nbsp; Google Pay.
          </a>
        </span>
      )
    },
    {
      question: 'Как перевести деньги с предоплаченной на другую карту?',
      answer: <span>Переводить с предоплаченной карты нельзя</span>
    },
    {
      question: 'Как снять наличные с карты?',
      answer: 'Снять деньги с предоплаченной карты нельзя.'
    }
  ],
  [
    {
      question:
        'Нужно ли уведомлять налоговые органы своей страны об открытии предоплаченной карты в иностранном банке?',
      answer:
        'Предоплаченные карты не предполагают открытия полноценного банковского счёта. Поэтому уведомлять налоговые органы об открытии такой карты не нужно.'
    }
  ],
  [
    {
      question: 'Я потерял данные карты, что делать?',
      answer: 'К сожалению, восстановить данные карты, перевыпустить её или вернуть вам оставшиеся деньги невозможно.'
    },
    {
      question: 'Не пришла SMS с данными карты ',
      answer: (
        <span>
          Обратитесь в службу заботы о пользователях: <br /> 8 800 555 89 90 (для звонков) <br /> +7 776 0 595 595
          (whatsapp для клиентов за рубежом) <br /> salem@bankffin.kz
        </span>
      )
    },
    {
      question: 'Как связаться со службой поддержки?',
      answer: (
        <span>
          8 800 555 89 90 (для звонков) <br /> +7 776 0 595 595 (whatsapp для клиентов за рубежом) <br />{' '}
          salem@bankffin.kz
        </span>
      )
    }
  ]
];
